import styles from './ScrollMarksContainer.module.css'

export const scrollMarksContainerID = 'find-result-marks-container'

export function ScrollMarksContainer() {
  return <div className={styles.scrollMarksContainer} id={scrollMarksContainerID} />
}
